import script from "./FormContent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormContent.vue?vue&type=script&setup=true&lang=js"

import "./FormContent.vue?vue&type=style&index=0&id=41951bc7&lang=scss"

const __exports__ = script;

export default __exports__